// @flow
import React, { Fragment } from 'react';
import { ArrowDown } from '@finect/tabular-icons/arrowDown';
import { Spinner } from './Spinner';
import { Inner, LoadButton } from './partials';

type Props = {
  loading: boolean,
  children?: any,
  light?: boolean,
  onClick?: Function,
  disabled: boolean,
  actionText?: string,
  href?: string,
  rel?: string
};

type State = {
  loading: boolean
};

export class LoadMore extends React.Component<Props, State> {
  static defaultProps = {
    disabled: false
  };

  state = {
    loading: this.props.loading
  };

  componentDidUpdate(prevProps: Props) {
    if (prevProps.loading !== this.props.loading) {
      this.setState({ loading: this.props.loading });
    }
  }

  handleAction = (event: any) => {
    const { loading } = this.state;

    // Con `href` el botón se pinta como <a> para que los rastreadores tengan una ruta
    // real a la página siguiente. Si además hay handler, la navegación la lleva el JS.
    if (event && this.props.href && this.props.onClick) event.preventDefault();

    !loading && this.setState({ loading: true }, () => setTimeout(() => this.setState({ loading: false }), 1000));

    this.props.onClick && this.props.onClick();
  };

  render() {
    const { children, light = false, loading, actionText, href, rel } = this.props;

    const linkProps = href
      ? {
        as: 'a',
        href,
        rel: rel ? rel : undefined
      }
      : {
        rel: rel ? rel : undefined
      };

    return (
      <Inner>
        <LoadButton
          role="button"
          light={light}
          disabled={this.props.disabled}
          onClick={this.handleAction}
          {...linkProps}
        >
          {loading ? <Spinner /> : null}
          {!loading ?
            actionText ? (
              <Fragment>
                {actionText}
                <ArrowDown />
              </Fragment>
            ) :
              children

            : null}
        </LoadButton>
      </Inner>
    );
  }
}
